import React from 'react';

const FormMasterSummary = ({ form, formCategories, formSubCategories, selectedCategory, onCategoryChange, onFormChange,shouldDisableFields,formType}) => {
debugger;

  return (
    <div>
      <div className="row">
        <div className="col-md-3">
          <div className="form-group">
            <label>Created On</label>
            <div>{new Date(form.createdOn).toLocaleDateString()}</div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <label>Created By</label>
            <div>{form.createdByContactName}</div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <label>Modified On</label>
            <div>{form.modifiedOn ? new Date(form.modifiedOn).toLocaleDateString() : 'N/A'}</div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <label>Modified By</label>
            <div id={form.modifiedByContactId}>{form.modifiedByContactName || 'N/A'}</div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-3">
          <div className="form-group">
            <label>Name</label>
            <input
              type="text"
              className="form-control"
              value={form.name || ''}
              onChange={(e) => onFormChange('name', e.target.value)}
              disabled={shouldDisableFields} 
            />
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-group">
            <label>Form Category</label>
            <select 
              className="form-control"
              value={selectedCategory}
              onChange={(e) => {
                onCategoryChange(e); // Update the category in the parent
                onFormChange('formCategoryId', e.target.value); // Update form state with the new category
              }}
              disabled={shouldDisableFields} 
            >
              <option value="">Select Category</option>
              {formCategories.map(category => (
                <option key={category.id} value={category.id}>
                  {category.name}
                </option> 
              ))}
            </select>
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-group">
            <label>Form Sub-Category</label>
            <select 
              className="form-control"
              value={form.formSubCategoryId || ''}
              onChange={(e) => onFormChange('formSubCategoryId', e.target.value)}
              disabled={shouldDisableFields} 
            >
              <option value="">Select Sub-Category</option>
              {formSubCategories.map(subCategory => (
                <option key={subCategory.id} value={subCategory.id}>
                  {subCategory.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="col-md-3">
  <div className="form-group">
    <label>Form Type</label>
    <select 
      className="form-control"
      value={form.formTypeValue || ''}  // Pre-select the option based on formTypeValue
      onChange={(e) => onFormChange('formTypeValue', e.target.value)}  // Update formTypeValue on change
      disabled={shouldDisableFields} 
    >
      
      {/* Conditionally set the selected option */}
      <option value="121440000">Internal</option>
      <option value="121440001">External</option>
      
    </select>
    
    {/* Display the formTypeText below the dropdown */}
    {/* {form.formTypeText && <small className="form-text text-muted">{form.formTypeText}</small>} */}
  </div>
</div>



        <div className="col-md-3">
          <div className="form-group">
            <label>Recipient Job Category</label>
            <div id={form.recipientJobCategoryId}>{form.recipientJobCategoryName || 'N/A'}</div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-group">
            <label>Recipient Contact:</label>
            <div id={form.recipientContactId}>{form.recipientContactName || 'N/A'}</div>
          </div>
        </div>

        {/* <div className="col-md-3">
          <div className="form-group">
            <label>Allow Submitter to Select Recipient</label>
            &nbsp;&nbsp;&nbsp;
            <input 
              type="checkbox"
              checked={form.allowSubmitterToSelectRecipient || false}
              onChange={(e) => onFormChange('allowSubmitterToSelectRecipient', e.target.checked)}
              disabled={shouldDisableFields} 
            />
          </div>
        </div> */}

  {!formType && (
        <div className="col-md-3">
          <div className="form-group">
            <label>For One Time Use?</label>
            &nbsp;&nbsp;&nbsp;
            <input 
              type="checkbox"
              checked={form.forOneTimeUse || false}
              onChange={(e) => onFormChange('forOneTimeUse', e.target.checked)}
              disabled={shouldDisableFields} 
            />
          </div>
        </div>
  )}
      </div>

    </div>
  );
};

export default FormMasterSummary;
